
//
// Load More
//

window.SetupLoadMore = function() {

	var isSearching = false;
	var buttons = null;
	var resultsPane = null;
	var currentPageIndex = 1; // zero indexed, but the first page will already be loaded

	///
	///
	///
	function doLoadMore() {

		if (!isSearching && window.moreResults) {

			isSearching = true;

			// show a loading animation
			doLoadingAnimation();

			// determine the paramaters to be passed to server method...
			var params = '';

			if (loadMoreOptions.searchTerm != '') {
				params = 'searchTerm=' + loadMoreOptions.searchTerm
			}

			if (typeof (loadMoreOptions.isTagSearch) == 'undefined' || loadMoreOptions.isTagSearch == '') {
				loadMoreOptions.isTagSearch = false;
			}

			if (params.length > 0)
				params += "&";

			params += 'currentPageIndex=' + currentPageIndex + '&pageSize=' + loadMoreOptions.pageSize + '&url=' + loadMoreOptions.searchPageUrl + '&isTagSearch=' + loadMoreOptions.isTagSearch;



			var xmlhttp = new XMLHttpRequest();

			xmlhttp.open("GET", '/umbraco/surface/' + loadMoreOptions.controller + '/' + loadMoreOptions.method + '?' + params, true);

			xmlhttp.onload = function (e) {
				if (xmlhttp.readyState === 4) {
					if (xmlhttp.status === 200) {

						currentPageIndex++;

						if (xmlhttp.responseText == '' || xmlhttp.responseText == 'false') {

							// assume no more results
							window.moreResults = false;

						} else {

							var data = xmlhttp.responseText;

							if (data != '') {
								// append the results pane with the new data
								resultsPane.innerHTML += data;

								// count the number of articles we now have
								var resultsCount = document.querySelectorAll('.' + loadMoreOptions.resultsPane + ' > div > article').length;

								// update the UI with the number of results now being shown
								var srSearchResultsCount = document.getElementsByClassName(loadMoreOptions.resultsCountLabel);

								if (srSearchResultsCount.length) {
									for (var i = 0; i < srSearchResultsCount.length; i++) {
										srSearchResultsCount[i].innerHTML = "Showing " + resultsCount + " of " + loadMoreOptions.totalResults + " results";
									}
								}

								// the moreResults varaible is stored within the loaded html partial - find it and evaluate it
								var arr = resultsPane.getElementsByTagName('script')
								if (arr.length) {
									eval(arr[arr.length - 1].innerHTML);
									// now remove the element
									for (var i = 0; i < arr.length; i++) {
										arr[i].parentNode.removeChild(arr[i]);
									}
								}

							} else {

								// assume no more results
								window.moreResults = false;
							} 

						}

					} else {
						console.error(xmlhttp.statusText);
					}

				}

				// complete
				isSearching = false;
				doLoadingAnimation();
				if (!window.moreResults) {
					doNoMoreResults();
				}
			};

			xmlhttp.onerror = function (e) {
				console.warn(xmlhttp.statusText);
				isSearching = false;
				doLoadingAnimation();
			};

			xmlhttp.send(null);

		} else {
			// either already loading more results or there are no more results to load
		}
	}

	///
	///
	///
	function doLoadingAnimation() {

		if (isSearching) {
			resultsPane.setAttribute('aria-busy', 'true');
			if (buttons && buttons.length > 0) {
				for (var i = 0; i < buttons.length; i++) {
					buttons[i].setAttribute('disabled', 'disabled');
					buttons[i].setAttribute('aria-disabled', 'true');
				}
			}
		} else {
			resultsPane.setAttribute('aria-busy', 'false');
			if (buttons && buttons.length > 0) {
				for (var i = 0; i < buttons.length; i++) {
					buttons[i].removeAttribute('disabled');
					buttons[i].removeAttribute('aria-disabled');
				}
			}
		}
	}

	///
	///
	///
	function doNoMoreResults() {
		if (loadMoreOptions.mode == 'button') {
			if (buttons.length > 0) {
				for (var i = 0; i < buttons.length; i++) {
					buttons[i].setAttribute('disabled', 'disabled');
					buttons[i].setAttribute('aria-disabled', 'true');
				}
			}
		} else {

		}
	}

	///
	///
	///
	function init() {

		if (typeof (loadMoreOptions) != 'undefined') {

			// check the loadMoreOptions contain minimum settings
			if (loadMoreOptions.mode != null &&
				loadMoreOptions.mode != '' &&
				loadMoreOptions.resultsPane != null &&
				loadMoreOptions.resultsPane != '' &&
				loadMoreOptions.pageSize != null &&
				loadMoreOptions.pageSize != '' &&
				loadMoreOptions.totalResults != null &&
				loadMoreOptions.totalResults != '' &&
				loadMoreOptions.controller != null &&
				loadMoreOptions.controller != '' &&
				loadMoreOptions.isTagSearch != null &&
				loadMoreOptions.isTagSearch != '' &&
				loadMoreOptions.method != null &&
				loadMoreOptions.method != '') {

				// find the Results Pane
				var resultsPanes = document.getElementsByClassName(loadMoreOptions.resultsPane);

				if (resultsPanes.length > 0) {
					resultsPane = resultsPanes[0];

					if (loadMoreOptions.mode == 'button') {
						// Button mode...

						// find the LoadMore button(s)
						buttons = document.getElementsByClassName(loadMoreOptions.button)

						if (buttons.length > 0) {
							// attach events to any buttons found
							for (var i = 0; i < buttons.length; i++) {
								var button = buttons[i];
								button.addEventListener('click', function () {
									doLoadMore();
								});
							}
						} else {
							// console.warn('The LoadMore button could not be found.');
						}


					} else if (loadMoreOptions.mode = 'scroll') {
						// Scroll mode...

						document.addEventListener("scroll", function (event) {
							var lastDiv = document.querySelector('.' + loadMoreOptions.resultsPane + ' > div > article:last-child');
							var lastDivOffset = lastDiv.offsetTop + lastDiv.clientHeight;
							var pageOffset = window.pageYOffset + window.innerHeight;

							if (pageOffset > lastDivOffset - 20) {
								doLoadMore();
							}
						});

					} else {
						console.warn('The LoadMore Mode has not been set to either button or scroll.');
					}

				} else {
					console.warn("The LoadMore resultsPane was not found.")
				}

			} else {
				console.warn('The LoadMore options are misconfigured.')
			}

		} else {
			// console.warn('loadMoreOptions not set for LoadMore functionality');
		}
	}

	//
	// Main Entry Point
	//
	init();
}

if (document.readyState !== 'loading') {
	window.SetupLoadMore();
} else {
	document.addEventListener('DOMContentLoaded', function () {
		window.SetupLoadMore();
	});
}